import { ReactElement } from "react";

import { AccessReviewStatus } from "@oneleet/api_client";

import { CheckIcon, CircleDotDashedIcon, HourglassIcon } from "lucide-react";

import { Badge } from "@oneleet/components";

type BadgeColor = Parameters<typeof Badge>["0"]["color"];

export const colorByAccessReviewStatus: Record<AccessReviewStatus, BadgeColor> =
  {
    [AccessReviewStatus.PLANNED]: "plain",
    [AccessReviewStatus.IN_PROGRESS]: "yellow",
    [AccessReviewStatus.COMPLETED]: "green",
  };

export const iconByAccessReviewStatus: Record<
  AccessReviewStatus,
  ReactElement<{ className?: string | undefined }> | undefined
> = {
  [AccessReviewStatus.PLANNED]: <HourglassIcon />,
  [AccessReviewStatus.IN_PROGRESS]: <CircleDotDashedIcon />,
  [AccessReviewStatus.COMPLETED]: <CheckIcon />,
};
